import { INDUSTRIES, studiesByIndustry } from "@/content/case-studies";
import { cn } from "@/lib/utils";
import { CaseStudyCard } from "./case-study-card";

interface StackedCaseStudiesProps {
  /** 1 for mobile (<768), 2 for tablet (768-1023). */
  columns?: 1 | 2;
}

// Tablet + mobile: no pin, no rail — cards stacked under industry headings.
export function StackedCaseStudies({ columns = 1 }: StackedCaseStudiesProps) {
  return (
    <div className="mx-auto w-full max-w-5xl">
      {INDUSTRIES.map((industry) => (
        <div key={industry.id} className="mb-12 last:mb-0">
          <div className="mb-5 flex items-center gap-3">
            <h3 className="font-body text-xs uppercase tracking-[0.18em] text-[#7c7e80]">
              {industry.short}
            </h3>
            <span className="h-px flex-1 bg-[#353739]" />
          </div>
          <div
            className={cn("gap-4", columns === 2 ? "grid grid-cols-2" : "flex flex-col")}
          >
            {studiesByIndustry(industry.id).map((study) => (
              <CaseStudyCard key={study.slug} study={study} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
